import axios from "../apis/django.instance";

export const getPrioritiesListService = () => {
  return axios.get("/api/projects/list_priority/"); // must be in this format in order to mock implementation in unit test
};
